export default "__VITE_ASSET__lNd8ROsd__"